/**
 * 获取单条评论
 * @param id 评论ID
 * @param page 分页
 * @param order 排序
 * @returns 评论列表
 */
export async function fetchCommentById(id: number) {
  return http
    .get<{
      comment: CommentDetail
    }>('/v1/comment/get', {
      id,
      html: 1
    })
    .then((res) => res.data.comment)
}
